import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const DownFromTop = [
    trigger('DownFromTop', [
        transition(':enter', [
            style({transform: 'translateY(-100vh)'}),
            animate('150ms', style({transform: 'translateX(0px)'})),
        ]),
    ])    
]